import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const Products = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await api.get('/ecommerce/products');
      setProducts(response.data.products || []);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch products:', err);
      const errorMsg = err.response?.data?.error || err.response?.data?.msg || err.message || 'Failed to fetch products';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    navigate('/products/new');
  };

  const handleEdit = (productId) => {
    navigate(`/products/${productId}/edit`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this product?')) return;
    try {
      await api.delete(`/ecommerce/products/${id}`);
      setSuccess('Product deleted');
      fetchProducts();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete');
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <nav className="breadcrumb">
        <button onClick={() => navigate('/dashboard')} className="breadcrumb-link">Dashboard</button>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Products</span>
      </nav>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '3px solid #EF4444' }}>
          <div>
            <h2 style={{ color: 'var(--gray-900)', fontSize: '1.5rem', fontWeight: 'bold', margin: '0 0 0.25rem 0' }}>
              🛍️ Products
            </h2>
            <p style={{ color: 'var(--gray-600)', margin: 0, fontSize: '0.875rem' }}>
              Manage your product catalog
            </p>
          </div>
          <button onClick={handleCreate} className="btn btn-primary">➕ Add Product</button>
        </div>

        {error && (
          <div style={{ backgroundColor: 'var(--red-50)', border: '1px solid var(--red-200)', color: 'var(--red-800)', padding: '0.75rem', borderRadius: '8px', marginBottom: '1rem', cursor: 'pointer' }} onClick={() => setError(null)}>
            {error}
          </div>
        )}

        {success && (
          <div style={{ backgroundColor: 'var(--success-50)', border: '1px solid var(--success-500)', color: 'var(--success-700)', padding: '0.75rem', borderRadius: '8px', marginBottom: '1rem', cursor: 'pointer' }} onClick={() => setSuccess(null)}>
            {success}
          </div>
        )}

        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: 'var(--gray-50)', borderBottom: '1px solid var(--gray-200)' }}>
              <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: 'var(--gray-700)' }}>Name</th>
              <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: 'var(--gray-700)' }}>SKU</th>
              <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: 'var(--gray-700)' }}>Price</th>
              <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: 'var(--gray-700)' }}>Stock</th>
              <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: 'var(--gray-700)' }}>Status</th>
              <th style={{ padding: '0.75rem', textAlign: 'center', fontSize: '0.875rem', fontWeight: '600', color: 'var(--gray-700)' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.length === 0 ? (
              <tr><td colSpan="6" style={{ padding: '2rem', textAlign: 'center', color: 'var(--gray-500)' }}>No products found</td></tr>
            ) : (
              products.map((product) => (
                <tr key={product.id} style={{ borderBottom: '1px solid var(--gray-200)' }}>
                  <td style={{ padding: '0.75rem' }}>{product.name}</td>
                  <td style={{ padding: '0.75rem' }}>{product.sku || '-'}</td>
                  <td style={{ padding: '0.75rem' }}>${parseFloat(product.price || 0).toFixed(2)}</td>
                  <td style={{ padding: '0.75rem' }}>{product.stock_quantity || 0}</td>
                  <td style={{ padding: '0.75rem' }}>
                    <span className={`badge badge-${product.status === 'active' ? 'success' : 'secondary'}`}>
                      {product.status}
                    </span>
                  </td>
                  <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                    <button onClick={() => handleEdit(product.id)} className="btn btn-sm btn-outline" style={{ marginRight: '0.5rem' }}>Edit</button>
                    <button onClick={() => handleDelete(product.id)} className="btn btn-sm btn-danger">Delete</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Products;
